import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addBettingSelectionMapping } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";
import { AddBettingSelectionMappingParams } from "@/types/ApiResponses/BettingSelection";

export const useAddBettingSelectionMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddBettingSelectionMappingParams) => addBettingSelectionMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingSelectionsQueryKeys.BettingSelectionMappings, variables.selectionId],
      });
    },
  });
};
